/** Scale a source into a frame without stretching (letterbox / pillarbox). */
export function containScale(
  srcW: number,
  srcH: number,
  frameW: number,
  frameH: number
): { scaleX: number; scaleY: number } {
  if (!srcW || !srcH || !frameW || !frameH) return { scaleX: 1, scaleY: 1 };
  const srcAspect = srcW / srcH;
  const frameAspect = frameW / frameH;
  if (srcAspect > frameAspect) {
    return { scaleX: 1, scaleY: frameAspect / srcAspect };
  }
  return { scaleX: srcAspect / frameAspect, scaleY: 1 };
}
